var nanobus = require( 'nanobus' );

export default class CreateButton {

	constructor() {
		this.element = this.createElement();
		this.state = true;
		this.events = nanobus();

		this.placeElement();
		this.initEvents();
	}

	placeElement() {
		let previousElement = document.querySelector( '.page-title-action' );

		if ( previousElement ) {
			setTimeout( () => {
				previousElement.insertAdjacentElement( 'afterend', this.element );
			}, 200 );

		}
	}

	initEvents() {
		this.element.addEventListener( 'click', e => {
			e.preventDefault();

			if ( this.state ) {
				this.events.emit( 'click' );
			}
		} );
	}

	getElement() {
		return this.element;
	}

	hide() {
		this.getElement().style.display = 'none';
	}

	show() {
		this.getElement().style.display = 'inline-block';
	}

	enable() {
		this.show();
		this.state = true;
	}

	disable() {
		this.hide();
		this.state = false;
	}

	createElement() {
		let element = document.createElement( 'a' );

		element.classList.add( 'ac-button' );
		element.classList.add( 'ac-add-new-inline' );
		element.classList.add( 'add-new-h2' );
		element.id = 'ac-button-add-new-inline';
		element.innerText = ACP_ADD_NEW_INLINE.i18n.add_new;

		return element;
	}

}